module.exports = __webpack_public_path__ + "img/1F920.10d24d50.svg";